<template>
  <div
    v-bind="$attrs"
    class="space-y-6 w-full mx-auto"
  >
    <div v-if="outOfStockItems.length > 0">
      <v-cart-summary-out-of-stock-item
        v-for="item in outOfStockItems"
        :key="item.id"
        :item="item"
        class="flex items-center justify-between border-b pb-6"
      />
    </div>
    <v-cart-summary-item
      v-for="item in cart?.items"
      :key="item.id"
      :item="item"
      :is-pro="cart.isPro"
      :cart-display="cartDisplay"
      :is-fetching="isFetching"
      @item-out-of-stock="handleItemOutOfStock"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import VCartSummaryItem from './VCartSummaryItem.vue';
import VCartSummaryOutOfStockItem from './VCartSummaryOutOfStockItem.vue';

const emit = defineEmits(['item-out-of-stock']);

defineProps({
  cart: {
    type: Object,
    required: true,
  },
  cartDisplay: {
    type: Boolean,
    default: false,
  },
  isFetching: {
    type: Boolean,
    default: false,
  },
});

const outOfStockItems = ref([]);

function handleItemOutOfStock(item) {
  emit('item-out-of-stock', item);
  outOfStockItems.value.push(item);
}
</script>
